<template>
    <div class="consent-wrapper" :class="machineName">
        <div class="consent-banner position-absolute" :class="machineName">
            <div class="border-radius-main w-100 p-3 p-lg-5 bg-white text-center shadow-2">
                <div @click="removePopup" class="close-popup pointer position-absolute">
                    <font-awesome-icon class="me-2" icon="times"/>
                </div>
                <h2 class="mb-3 h3 text-left">{{ consent.title }}</h2>
                <p class="p mb-4 text-left">{{ consent.consentInfo }}</p>
                <div class="btn btn-primary w-100 accept-btn" @click="acceptConsent">{{ consent.accept }}</div>
                <div class="d-flex justify-content-end mt-5 me-2 position-relative">
                    <div class="cmplogo2" tabindex="-1">
                        <span class="cmplogo2hx">powered by </span>
                        <a href="https://www.consentmanager.net/?utm_source=cmplogo&amp;utm_medium=banner&amp;utm_campaign=cmplogo&amp;utm_term=31033" target="_top"><img src="https://cdn.consentmanager.mgr.consensu.org/delivery/cmplogo.svg" style="width:16px; height:16px" width="16" height="16" border="0" alt="consentmanager.net" data-cmp-info="9">
                            <span class="cmplogo2h">consentmanager.net</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'consent-preview',
    props: {
        cname: {
            type: String
        },
        consentInfo: {
            type: String
        }
    },
    data () {
        return {
            consent: {
                title: Drupal.t('We need your consent please'),
                consentInfo: this.consentInfo,
                accept: Drupal.t('Accept')
            }
        }
    },
    computed: {
        machineName () {
            return this.cname.replace(/\s+/g, '-').toLowerCase()
        }
    },
    methods: {
        acceptConsent: function () {
            this.$emit('acceptConsent')
        },
        removePopup: function () {
            this.$store.dispatch('setStore', null)
            this.$store.dispatch('skipProceed', null)
            this.$store.dispatch('etermin/updateSteps', 0)
            this.$store.dispatch('etermin/resetCreated', null)
            this.$store.dispatch('notification/clear', null, {
                root: true
            })
            this.$destroy()
        }
    }
}
</script>
